export default __webpack_public_path__ + "static/media/Icon-grid-grey.0e6202f2.svg";